import {
  ColumnDetail,
  ComplexSelectionFormValue,
  RowDetail,
} from '../../../../../../../ui/gzSelectableTableRowGroup/types';
import {
  AntimalwareDynamicThreatDefenseDetectionLevelLevelType,
  Category,
} from '@nirvana/shared/dtos/types/policies/common';
import { translateFn } from '../../../../../../../utils/translator.helper';
import {
  AntimalwareDynamicThreatDefenseProtectionLevelUiValue,
  AntimalwareDynamicThreatDefenseSearchableKeywords,
} from '../../../../utils/uiSettings/antimalware/antimalware.types';
import { SearchableKeyword } from '../../../../../../../ui/gzSearchableAccordionsPanel/types';

export enum AntimalwareDynamicThreatDefenseProtectionLevelKey {
  TARGETED_ATTACK = 'targetedAttack',
  SUSPICIOUS_FILES_AND_NETWORK_TRAFFIC = 'suspiciousFilesAndNetworkTraffic',
  EXPLOITS = 'exploits',
  RANSOMWARE = 'ransomware',
  GRAYWARE = 'grayware',
}

export const columns = (): ColumnDetail<AntimalwareDynamicThreatDefenseDetectionLevelLevelType>[] => {
  return [
    {
      column: AntimalwareDynamicThreatDefenseDetectionLevelLevelType.AGGRESSIVE,
      label: translateFn('Aggressive'),
    },
    {
      column: AntimalwareDynamicThreatDefenseDetectionLevelLevelType.NORMAL,
      label: translateFn('Normal'),
    },
    {
      column: AntimalwareDynamicThreatDefenseDetectionLevelLevelType.PERMISSIVE,
      label: translateFn('Permissive'),
    },
  ];
};

export const rows = (searchableKeywords: {
  [type in AntimalwareDynamicThreatDefenseSearchableKeywords]: SearchableKeyword;
}): RowDetail<
  AntimalwareDynamicThreatDefenseProtectionLevelKey,
  AntimalwareDynamicThreatDefenseDetectionLevelLevelType
>[] => [
  {
    key: AntimalwareDynamicThreatDefenseProtectionLevelKey.TARGETED_ATTACK,
    label: searchableKeywords[AntimalwareDynamicThreatDefenseSearchableKeywords.TargetedAttack].translatedLabel,
  },
  {
    key: AntimalwareDynamicThreatDefenseProtectionLevelKey.SUSPICIOUS_FILES_AND_NETWORK_TRAFFIC,
    label:
      searchableKeywords[AntimalwareDynamicThreatDefenseSearchableKeywords.SuspiciousFilesAndNetworkTraffic]
        .translatedLabel,
  },
  {
    key: AntimalwareDynamicThreatDefenseProtectionLevelKey.EXPLOITS,
    label: searchableKeywords[AntimalwareDynamicThreatDefenseSearchableKeywords.Exploits].translatedLabel,
  },
  {
    key: AntimalwareDynamicThreatDefenseProtectionLevelKey.RANSOMWARE,
    label: searchableKeywords[AntimalwareDynamicThreatDefenseSearchableKeywords.Ransomware].translatedLabel,
  },
  {
    key: AntimalwareDynamicThreatDefenseProtectionLevelKey.GRAYWARE,
    label: searchableKeywords[AntimalwareDynamicThreatDefenseSearchableKeywords.Grayware].translatedLabel,
  },
];

export function convertDbValueToFormValue(
  categories: AntimalwareDynamicThreatDefenseProtectionLevelUiValue
): ComplexSelectionFormValue<
  AntimalwareDynamicThreatDefenseProtectionLevelKey,
  AntimalwareDynamicThreatDefenseDetectionLevelLevelType
> {
  return Object.fromEntries(
    Object.entries(categories).map(([key, value]) => [
      key as Category,
      {
        enabled: value.enable,
        column: value.detectionLevel,
      },
    ])
  );
}

export function convertFormValueToDbValue(
  categories: ComplexSelectionFormValue<
    AntimalwareDynamicThreatDefenseProtectionLevelKey,
    AntimalwareDynamicThreatDefenseDetectionLevelLevelType
  >
) {
  return Object.fromEntries(
    Object.entries(categories).map(([key, value]) => [
      key as Category,
      {
        enable: value.enabled,
        detectionLevel: value.column,
      },
    ])
  );
}
